
import React from 'react';
import {FaInfoCircle} from 'react-icons/fa'
import Layout from '../Layout/Layout';
import PageHeader from '../PageHeader/PageHeader';

const FAQScreen = props => {
  return (
    <Layout product='ica'>
    <PageHeader title='FAQ'>

    <div>
      <h1>Overview</h1>

      <p><b>Who should take this assessment?</b></p>
      <p>The assessment is best answered by a key executive of the organization with understanding of existing operations and knowledge of the strategic future direction of the organization.</p>

      <p><b>What if our score is below the minimum threshold of the Dream Exchange?</b></p>
      <p>In the unlikely (but possible) event that your organization scores below the minimum threshold, you will receive a full refund of your fee and a consultation from the Dream Exchange on the reasons for the scoring and recommended activities for improvement.</p>

      <h1>Login</h1>
      <p><b>How do I access the introductory assessment?</b></p>
      <p>Upon successful registration, you will receive an email which will include the username, temporary password and link to the web portal.</p>

      <p><b>Are there requirements for a strong password?</b></p>
      <p>Passwords require a minimum length of 8 characters and must include a number, special character and at least one upper case and one lower case letter.</p>

      <p><b>Why wasn’t I asked for my password the next time I accessed the site?</b></p>
      <p>The site uses a system that records certain information on your computer, so you don’t have to log in every time This is called token-based access: the token essentially contains your password for a duration. The token has a life, so you will be asked for your login information from time to time.</p>

      <p><b>What if I don’t want to use the token-based access?</b></p>
      <p>A log out button is provided at the top right of the screen or in the dropdown menu on smaller devices.</p>

      <p><b>What if I forget my password?</b></p>
      <p>There is a “Forgot password?” link on the login screen. Select this phrase. You will be sent a code to your email and/or your text number as part of the process to ensure that you are you.</p>

      <p><b>What if I forget my username?</b></p>
      <p>Your username is your email address at the time of registration.</p>

      <h1>Site Navigation</h1>

      <p><b>How do I access the parts of the assessment?</b></p>
      <p>The Home progress screen is the first available screen. This screen presents a set of tiles in the center of the screen and, on larger screens, a set of buttons may appear on the left side of the screen. On smaller screens, these buttons are available in the dropdown “hamburger” menu in the upper right.</p>
      <p>The site is navigated either by selecting a tile in the center of the screen or by selecting a button or dropdown menu item.</p>

      <p><b>What are the components of the assessment?</b></p>
      <p>The Introductory Company Assessment is comprised of three sections: Company, Upload Files and Questionnaire which are described in more detail below. The tiles at the center of the Home screen conveys the availability and completeness of a particular section.</p>

      <p><b>Can I go back and change the information I supply?</b></p>
      <p>You can go back and change any information in a section until the section is designated as complete.</p>

      <p><b>Why can’t I change the information in a completed activity?</b></p>
      <p>The information supplied in earlier sections are used in subsequent sections. Once a section is designated as complete, the system performs queries based on this information for other sections of the assessment.</p>

      <p><b>What if the tile doesn’t reflect the correct state of the activity?</b></p>
      <p>Some processes and calculations may take a few minutes to complete. If this occurs, wait a minute or so and refresh the screen. In most instances, this procedure will resolve the issue.</p>

      <h1>Company</h1>

      <p><b>Why is some of the information pre-filled?</b></p>
      <p>As a convenience, the information provided at registration is used to pre-fill fields in the Company screen and may be changed.
        <b><u><i>However, it is important to know that the company name has already been used to search the public records. Changing the name will only change the name on the report.</i></u></b></p>

      <p><b>Is all the information required?</b></p>
      <p>Any field designated with an asterisk (*) at the end of the title is required. All other fields are optional.</p>

      <p><b>Do I need to complete required fields?</b></p>
      <p>Yes. The SAVE button will not work until all the required fields are supplied with information. Incomplete required fields will be outlined in red.</p>

      <p><b>Why did some of my information disappear?</b></p>
      <p>If you navigate from the Company screen before you click SAVE, then only the original registration information will appear on the screen. Complete the Company activity and hit SAVE before leaving the screen.</p>

      <p><b>What is a NAICS code?</b></p>
      <p>NAICS is an acronym for North American Industry Classification System. The selection of a primary NAICS code is a required field and identifies the industry that best describes the primary industry of your organization.</p>

      <p><b>How do I find my NAICS code?</b></p>
      <p>The first method is to select the phrase <b><u><i>“Search for NAICS by sector or keyword”</i></u></b>. Once selected, a list of industry sectors will become available. Select the sector which best describes the industry of the primary products and services of your organization. Once a sector is selected, select the sub industry that best describes your industry.</p>
      <p>If the first method does not result in a satisfactory result, select the “Clear selection” phrase to return to the sector menu.</p>
      <p>An alternative method is to enter one or two keywords for your industry in the blank at the top of the screen and select an industry from the list.</p>
      <p>It is important to spend time and carefully consider the most appropriate NAICS industry code since many of the subsequent questions and assessment are based on this selection.</p>

      <p><b>I know my NAICS code but can’t find it in the lists.</b></p>
      <p>The NAICS codes presented are specifically chosen to coordinate certain information. If you do not see a particular NAICS sub code, consider using Choose the one that best fits your industry.</p>

      <h1>Upload Files</h1>

      <p><b>What is the Upload tile for?</b></p>
      <p>Documents may be uploaded for future reference by DreamEx Personnel</p>

      <h1>Questionnaire</h1>
      <p><b>Do I have to complete all the questions?</b></p>
      <p>Yes, you must complete every question in every section. On some questions, you may notice an <span style={{color: 'blue'}}><FaInfoCircle size={24}/></span> next to the question. This indicates that there is additional information and guidance to help you answer the question.</p>

      <p><b>Can I go away and come back to answer questions at a later time?</b></p>
      <p>As each question is answered, the answer is saved “to the cloud.” You can safely leave the questionnaire and come back later to amend any previously entered information and complete any unanswered questions.</p>

      <p><b>Is there a specific sequence I must follow when answering the Questionnaire section?</b></p>
      <p>No. However, the General Information section should be completed first since some questions in the other sections are based on the responses in this section.</p>

      <p><b>How do I start the questionnaire?</b></p>
      <p>The first tile selected should be the General Information tile.</p>

      <p><b>What if I need to do some research to answer a question?</b></p>
      <p>Simply hit NEXT and skip that questions. Every question also has a “Return to Sections” link that can be selected which will return you to the Sections tiles.</p>

      <p><b>I have come to the end of the section, what does the COMPLETE button do?</b></p>
      <p>Activation of the COMPLETE button in a Section is only available if every answer in the Section has been answered. Activation will return you to the Questionnaire tile screen.</p>

      <p><b>Can I go back and change my answers after completing all the questions in a section?</b></p>
      <p>Yes</p>

      <p><b>The section was complete before but now is not complete, what happened?</b></p>
      <p>This situation may occur if you change an answer in another Section. If so, you will need to review the questions and answer any additional questions in that Section.</p>

      <p><b>All the questionnaire tiles are complete, now what do I do?</b></p>
      <p>On the questionnaire tile page, you will notice all the tiles are marked COMLETED if every question has been answered. The COMPLETE button at the top right is now in full color and available. Once the COMPLETE is selected, the questionnaire becomes closed and the generation of the report will begin.</p>

      <h1>Report</h1>
      <p><b>How do I get the report?</b></p>
      <p>Once the questionnaire is closed, the system will automatically generate the report. Please be patient, it may take a few minutes to produce the report and make it available for viewing. When the report is available, the REPORT tile will be marked COMPLETED.</p>
      <p>If more than five minutes have elapsed and the REPORT is not marked COMPLETED, then refresh the screen.</p>

      <p><b>I selected report and the report did not display.</b></p>
      <p>The system is designed to present the report in a separate window. If the report does not display, make sure that window popups are enabled. In Apple Safari, this is done through the Preferences menu under the Safari menu. Other browsers may prompt you to enable window popups.</p>

      <p><b>I selected the report and it gave me an access error.</b></p>
      <p>This error usually means the report is not ready. Please wait a few minutes and try again.</p>

      <p><b>I saved the URL of the report, but it no longer works.</b></p>
      <p>This is a security feature of the system. The URL is only active for a brief period of time. To retrieve the report again, just login and select the report button. You can also save the report to a PDF and print the report from your browser.</p>
    </div>
    </PageHeader>
  </Layout>
  )
}
export default FAQScreen
